import { Injectable } from '@angular/core';
import {from, Observable, of, throwError} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {classToPlain, plainToClass} from 'class-transformer';
import {db} from "../../dexie/db";

import { SOPutWork } from './so-put-work';
import { SOGetWork } from './so-get-work';
import { SOPostWork } from './so-post-work';
import { SODeleteWork } from './so-delete-work';
import {SORespWork} from './so-resp-work';
import {SOPluralWork} from './so-plural-work';

import {MMEntityService} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import {MMEntityServiceBase} from 'lionheartland';
import {HttpHeaders} from "@angular/common/http";

export class EOWorkService extends MMEntityServiceBase implements MMEntityService {

  constructor(
    public entityCore: EntityCoreProtocol,
  ) {
    super('work', entityCore);
  }

  /** GET Work by id. Will 404 if id not found */
  get(request: SOGetWork): Observable<SOPluralWork> {
    return this.httpClient.get<SOPluralWork>(this.makeGetUri(request), this.httpOptions).pipe(
      map(resp => plainToClass(SOPluralWork, resp)),
      tap(async (response: SOPluralWork) => {
        this.log(`fetched Work`);
        // After a successful server response, update IndexedDB
        const activities = response.toWorks(); // Convert your response to an array of Work instances
        const promises = activities.map(work => db.works.put(work));
        await Promise.all(promises); // Wait for all the IndexedDB update operations to complete
      }),
      catchError(this.handleError<SOPluralWork>(`get Work`))
    );
  }

    /** GETCACHE for initial display with CacheQueryProtocol */
    getCache(cacheQuery: any): Observable<SOPluralWork> {
        console.log("GETCACHE", cacheQuery);

        if (cacheQuery.filterKey === 'work' && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on parent and organization")
            return from(db.works.where('parentUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(worksArray => this.processWorks(worksArray)),
                catchError(error => this.handleQueryError(error))
            );
        }
        else if (cacheQuery.filterKey + "s" == "deficiency" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.works.where('deficiencyUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(worksArray => this.processWorks(worksArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "period" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.works.where('periodUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(worksArray => this.processWorks(worksArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "planWorkAssociations" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.works.where('planWorkAssociationsUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(worksArray => this.processWorks(worksArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "backlog" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.works.where('backlogUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(worksArray => this.processWorks(worksArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "project" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.works.where('projectUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(worksArray => this.processWorks(worksArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterKey + "s" == "organization" && cacheQuery.filterValue && cacheQuery.filterOrganization)
        {
            console.log("cache filtering based on relationship and organization")
            return from(db.works.where('organizationUid').equals(cacheQuery.filterValue).and(item => item.organizationUid === cacheQuery.filterOrganization.uid).toArray()).pipe(
                map(worksArray => this.processWorks(worksArray)),
                catchError(error => this.handleQueryError(error))
            );
        }        else if (cacheQuery.filterOrganization || cacheQuery.organization.uid)
        {
            console.log("tripped organization for cache query")
            if ( cacheQuery?.filterOrganization != null )
            {
                console.log("cache filtering based on organization CQP", cacheQuery)
                return from(db.works.where('organizationUid').equals(cacheQuery.filterOrganization).toArray()).pipe(
                    map(worksArray => this.processWorks(worksArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else if ( cacheQuery?.organization?.uid != null )
            {
                console.log("UID:", cacheQuery.organization.uid)
                console.log("cache filtering based on organization SOGet")
                return from(db.works.where('organizationUid').equals(cacheQuery.organization.uid).toArray()).pipe(
                    map(worksArray => this.processWorks(worksArray)),
                    catchError(error => this.handleQueryError(error))
                );
            }
            else
            {
                console.log("null organization")
            }
        }
        else
        {
            console.log("cache no filter")
            return from(db.works.toArray()).pipe(
                map((worksArray) => {
                    // Convert the array of plain objects to an array of SORespWork instances
                    const sorWorks = worksArray.map(req => plainToClass(SORespWork, req));
                    // Create and return a new instance of SOPluralWork
                    const pluralWork = new SOPluralWork();
                    pluralWork.objects = sorWorks;
                    pluralWork.nextOffset = null; // Assuming there is no pagination in cache
                    return pluralWork;
                }),
                catchError(error => this.handleQueryError(error))
            );
        }
    }

    private processWorks(worksArray) {
        const sorWorks = worksArray.map(req => plainToClass(SORespWork, req));
        const pluralWork = new SOPluralWork();
        pluralWork.objects = sorWorks;
        pluralWork.nextOffset = null;
        return pluralWork;
    }

    private handleQueryError(error) {
        console.error('Error in query:', error);
        return throwError(error); // Return an observable error
    }

post(request: SOPostWork): Observable<SORespWork> {
  return this.httpClient.post<SORespWork>(this.coreUrl + this.route, request, this.httpOptions).pipe(
    map(resp => plainToClass(SORespWork, resp)),

    tap(async (response: SORespWork) => {
      this.log(`added Work w/ id=${response.uid}`);
      // After a successful server response, update IndexedDB
      console.log("here", response);
      console.log("here request", request);
      await db.works.add(response.toWork());
    }),
    catchError(this.handleError<SORespWork>('Work post'))
  );
}


  put(request: SOPutWork): Observable<SORespWork> {
    const uid = request.uid;
    const uri = `${this.coreUrl}${this.route}/${uid}`;
    return this.httpClient.put<SORespWork>(uri, request, this.httpOptions).pipe(
      map(resp => plainToClass(SORespWork, resp)),
      tap(async (response: SORespWork) => {
        this.log(`edited Work w/ uid=${uid}`);
        // After a successful server response, update IndexedDB
        await db.works.put(response.toWork());
      }),
      catchError(this.handleError<SORespWork>('Work put'))
    );
  }


  delete(request: SODeleteWork): Observable<SORespWork> {
    return this.httpClient.delete<SORespWork>(this.makeDeleteUri(request), this.httpOptions).pipe(
      tap(async _ => {
        this.log(`deleted Work uid=${request.uid}`);
        // After a successful server response, update IndexedDB
        await db.works.delete(request.uid);
      }),
      catchError(this.handleError<SORespWork>('Work delete'))
    );
  }


}
